export default __webpack_public_path__ + "static/media/imgs4.cd892ac6.jpg";